
function getEquityPriceColorBasedOnValue(value) {
	// This function provide coloured value for the equity price display
	// eg. 697.05 -78.55 (2.42)
	// Color can be applied to requried text based on the value passed

	const price = Number(value);

	if (price > 0) {
		return "secondary.profitGreen.400";
	} else if (price < 0) {
		return "secondary.lossRed.400";
	} else {
		return "content.secondary";
	}
}

// const appendPercentage(value) => `${value}%`;

// const sign =() =>  {-} ;
// If required move to a separte file

const equityBaseService = {
	getEquityPriceColorBasedOnValue,
};

export default equityBaseService;
